<script lang="ts">

  /* This component was poorly edited in the hopes to send the new footer to production */
  /* TODO: Refactor component to follow project standards */

  import { t } from 'svelte-i18n';
  import Button from '../../shared/button.svelte';
  import { setModalHash } from '../../shared/modal-store';

  export let element: HTMLElement = undefined;

  function openEmailFormModal() {
    setModalHash('contact-form');
  }
</script>

<style>
  .e-footer-text {
    margin: 0px 20px;
    opacity: 0.88;
    font-size: 28px;
    line-height: 150%;

    @media screen and (max-width: 1024px) {
      font-size: 25px;
    }

    @media screen and (max-width: 714px) {
      font-size: 20px;
    }

    @media screen and (max-width: 512px) {
      font-size: 18px;
    }
  }

</style>

<section
  class="relative w-full flex flex-col items-center bg-blue-bg selection:bg-text-dark selection:text-blue flex-1"
>
  <div
    class="flex flex-1 flex-col items-center justify-center lg:max-w-[680px] py-20 xs:py-24 sm:py-28 md2:py-32 lg:py-36 xl:py-40"
  >
    <h1 class="e-footer-text text-white selection:bg-text-dark selection:text-blue text-center pb-2 pt-0 leading-snug">
      {$t('HOME.FOOTER.INTRO')}
    </h1>
    <h1 class="e-footer-text text-white selection:bg-text-dark selection:text-blue text-center  pt-0 lg:pb-[3em] pb-[2em] leading-snug">
      {$t('HOME.FOOTER.CAPACITY_LEFT')} <div class="c-flipper-number"></div> {$t('HOME.FOOTER.CAPACITY_RIGHT')} 
    </h1>
    <a on:click={openEmailFormModal} class="cursor-pointer" id="open_form_footer">
      <Button variant='yellow' short={true} label={$t('HOME.FOOTER.BUTTON')} />
    </a>
  </div>

  <span class="absolute bottom-[72px]" bind:this={element} />
</section>
